import { ElementRef, Injectable, QueryList, Renderer2 } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  FieldsToBeEdited,
  Fixing,
  Leg,
  LegSyncingFields,
  RfqLegSettings
} from '@approot/models';
import { ProductsConfigService } from '@approot/services';
import { shortUuid, SubscriptionSink, Utilities } from '@approot/utilities';
import { DynamicLegAttributeComponent } from '../../dynamic-leg-attribute/dynamic-leg-attribute.component';

@Injectable({
  providedIn: 'root'
})
export class LegHelperService {
  public onChangeInLegFn: () => void;
  public onChangeInLegPriceFn: () => void;
  public onFieldBlurredFn: (fieldName: string) => void;
  public onLegPresetLoadedFn: () => void;
  public onChangeInCounterParty: () => void;
  public firstLegTradeId: number;
  public legIndex: number;
  public leg: Leg;
  public legSyncingInfo: LegSyncingFields;
  public fieldsToBeEdited: FieldsToBeEdited;
  public form: FormGroup;
  public rfqExecutionSettings: RfqLegSettings;
  public presetsLoaded = false;
  public subSink = new SubscriptionSink();
  public requiredFixings: Fixing[] = [];
  public streamingWebsocketUUID = 'stream_' + shortUuid();
  public tradingMode = false;
  public legStrategy: any;
  public legAlive = true;
  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private productsConfigService: ProductsConfigService
  ) {}

  public qs(q: string): HTMLElement {
    const rootElem = this.elementRef.nativeElement as HTMLElement;
    return rootElem.querySelector(q) as HTMLElement;
  }

  public qsa(q: string): HTMLElement[] {
    const rootElem = this.elementRef.nativeElement as HTMLElement;
    return Array.from<HTMLElement>(rootElem.querySelectorAll(q));
  }

  public allLegsValid(
    legComponents: QueryList<DynamicLegAttributeComponent>
  ): boolean {
    return !legComponents.some(leg => !leg.isValid);
  }

  public setDateOnDelay(dateId: string, dateValue: string) {
    setTimeout(() => {
      // clarity design date has issues setting the value on creation
      let dateEl = this.qs('#' + dateId);
      if (dateEl) {
        this.renderer.setProperty(dateEl, 'value', dateValue);
      }
    });
  }

  public decimalCurrencyFormatter(attribute: string, crossType: string): void {
    const attributeCtrl = this.form.get(attribute);
    const crossCtrl = this.form.get(crossType);
    if (attributeCtrl?.value && crossCtrl?.value) {
      const value = Utilities.cleanFormattedNumeric(attributeCtrl.value);
      if (!isNaN(value)) {
        // format the decimals by passing the attribute value and its cross
        const formattedValue = this.productsConfigService.crossDecimalFormatter(
          value,
          crossCtrl.value
        );
        if (formattedValue !== attributeCtrl.value) {
          this.form.get(attribute).setValue(formattedValue);
        }
      }
    }
  }

  public valueToUseAsCross(allowCurrency?: boolean): string {
    // gets the cross that we are going to use
    if (this.form.get('cross')?.value) {
      return this.form.get('cross').value;
    } else if (
      this.form.get('depositCurrency')?.value &&
      this.form.get('alternativeCurrency')?.value
    ) {
      return this.productsConfigService.getCrossFromCurrencies(
        this.form.get('depositCurrency').value,
        this.form.get('alternativeCurrency').value
      );
    } else if (
      this.form.get('currency') &&
      this.form.get('currency').value &&
      allowCurrency
    ) {
      return this.form.get('currency').value;
    }
    return '';
  }
}
